var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sf-cnt-footer"},[_c('div',{staticClass:"sf-cnt-footer__contacts"},[_vm._v(_vm._s(_vm.phone)),(_vm.phone && _vm.email)?_c('span'):_vm._e(),_vm._v(_vm._s(_vm.email))]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sf-cnt-footer__page"},[_c('span',{staticClass:"pdfcrowd-page-number"})])
}]

export { render, staticRenderFns }